import { mapGetters } from 'vuex'
import TrackerTabs from '@/applications/scrum/components/TrackerTabs/TrackerTabs'
import Configuration from '@/agilis/util/Configuration'
import DumpUserActionMixin from '@/agilis/components/DataTableV2/common/dumpUserActionMixin'

export default {
  name: 'TrackerTabsMobile',
  mixins: [TrackerTabs, DumpUserActionMixin],
  data () {
    return {
      searchTxt: ''
    }
  },
  mounted () {
    this.$store.commit('mobileDataTableStore/setIsVisibleTrackerTabsIcon', this.trackerTabsMobile.length > 1)
  },
  computed: {
    ...mapGetters({
      authorizedAppTrackerTypes: 'contextStore/trackerTypes',
      menuState: 'mobileDataTableStore/openMenu',
      trackerTypeId: 'contextStore/trackerTypeId',
      'viewSearchState': 'mobileDataTableStore/isVisibleSearch',
      'searchTextState': 'mobileDataTableStore/getSearchTxt',
      'viewFiltersState': 'mobileDataTableStore/isVisibleSavedViews',
      'availableViews': 'mobileDataTableStore/getAvaibleViews',
      'viewFilterSelected': 'mobileDataTableStore/getSavedSelectedView',
      'userActivities': 'userActivityStore/userActivities'
    }),
    isViewRoute: function () {
      return this.$route.path.includes('view')
    },
    searchText: {
      get: function () {
        const lastUserActivity = this.userActivities(this.dumpRoute)?.search
        const searchTextState = this.searchTextState
        return lastUserActivity || searchTextState
      },
      set: function (newValue) {
        this.searchTxt = newValue
        this.$store.commit('mobileDataTableStore/setSearchTxt', this.userActivities(this.dumpRoute)?.search)
      }
    },
    trackerTabsMobile () {
      let trackers = []
      Object.entries(this.authorizedAppTrackerTypes).forEach(tracker => {
        trackers.push({
          disabled: !(tracker[1].dataTable && tracker[1].dataTable.mobile),
          id: tracker[0]
        })
      })
      return trackers.filter(tracker => !tracker.disabled)
    },
    menuIsOpen: {
      get: function () {
        return this.menuState
      },
      set: function (newValue) {
        this.$store.commit('mobileDataTableStore/setOpenMenu', false)
      }
    },
    tabId () {
      return Object.keys(this.authorizedAppTrackerTypes).find((element) => element === this.trackerTypeId)
    }
  },

  methods: {
    selectedView (viewSelected) {
      this.$store.commit('mobileDataTableStore/setSavedViewSelected', this.viewFilterSelected === viewSelected ? '' : viewSelected)
      this.$store.commit('mobileDataTableStore/setIsVisibleViews', false)
    },
    handleSearch (event) {
      // removed the length check, but added a 700 ms delay when the user starts typing a word.
      clearTimeout(this._timerId)
      this._timerId = setTimeout(() => {
        this.$store.commit('mobileDataTableStore/setSearchTxt', this.searchTxt)
        this.dumpUserAction({ search: this.searchTxt })
      }, 700)
    },
    overrideComponentId (trackerTypeId) {
      const componentId = this.authorizedAppTrackerTypes[trackerTypeId].dataTableComponentId || this.applicationDataTableOverride
      switch (componentId) {
        case 'ProductTable':
          return 'Product2Table'
        case 'ContactTable':
          return 'Contact2Table'
        default:
          return componentId
      }
    },
    selectTab (tabid) {
      this.$router.agilis.viewTrackerTable(tabid)
      this.$store.commit('mobileDataTableStore/setOpenMenu', false)
    },
    trackerDatatableConfiguration (trackerTypeId) {
      return Configuration.datatable.getDatatable({
        applicationId: this.applicationId,
        trackerTypeId: trackerTypeId,
        workspaceId: this.workspaceId
      })
    },
    componentResolverProps (trackerTypeId) {
      return {
        viewComponentId: 'TrackerDataTableView',
        configuration: this.trackerDatatableConfiguration(trackerTypeId),
        propTitle: this.trackerTitle(trackerTypeId),
        description: this.trackerDescription(trackerTypeId),
        api: this.trackerApi(trackerTypeId)
      }
    }
  }
}
